// Shared between the report modal, the submit API, and the admin queue.
// Keep these values in sync with the CHECK constraints in
// supabase/migrations/20260429_reports_system.sql.

export const REPORT_TARGET_TYPES = [
  'post',
  'comment',
  'profile',
  'group',
  'message',
  'job',
] as const;

export type ReportTargetType = (typeof REPORT_TARGET_TYPES)[number];

export const REPORT_REASONS = [
  { value: 'spam', label: 'Spam or scams' },
  { value: 'harassment_or_bullying', label: 'Harassment or bullying' },
  { value: 'hate_speech', label: 'Hate speech or slurs' },
  { value: 'sexual_or_nsfw', label: 'Sexual or NSFW content' },
  { value: 'violence_or_threats', label: 'Violence or threats' },
  { value: 'misinformation', label: 'Misinformation' },
  { value: 'impersonation', label: 'Impersonation' },
  { value: 'predatory_terms', label: 'Predatory or exploitative offer' },
  { value: 'ai_training_concern', label: 'Used for AI training without consent' },
  { value: 'other', label: 'Something else' },
] as const;

export type ReportReason = (typeof REPORT_REASONS)[number]['value'];

export const REPORT_STATUSES = [
  'pending',
  'reviewing',
  'resolved_kept',
  'resolved_removed',
  'dismissed',
] as const;

export type ReportStatus = (typeof REPORT_STATUSES)[number];

export const REPORT_STATUS_LABEL: Record<ReportStatus, string> = {
  pending: 'Pending',
  reviewing: 'Under review',
  resolved_kept: 'Kept',
  resolved_removed: 'Removed',
  dismissed: 'Dismissed',
};

export const REPORT_REASON_LABEL: Record<ReportReason, string> = REPORT_REASONS.reduce(
  (acc, r) => ({ ...acc, [r.value]: r.label }),
  {} as Record<ReportReason, string>
);

export const REPORT_DETAILS_MAX = 500;
